<template>
    <div>
      <div class="flex flex-col items-center justify-between gap-3 px-2 py-4 md:py-8 md:px-10 lg:gap-0 lg:flex-row border-y border-primary-light">
        <div class="flex flex-col items-center gap-6 md:gap-12 md:flex-row">
            <NuxtLinkLocale to="/"><img loading="lazy" decoding="async" class="w-[130px]" :src="logoTypoWhite" alt="Echopus logo" width="130" height="48"></NuxtLinkLocale>
            <ul class="flex items-center gap-4 text-sm">
                <li class="transition hover:bg-primary-light"><NuxtLinkLocale to="/terms/" >{{ $t('footer.terms') }}</NuxtLinkLocale></li>
                <li class="transition hover:bg-primary-light"><NuxtLinkLocale to="/privacy/" >{{ $t('footer.privacy') }}</NuxtLinkLocale></li>
                <li><span>&copy; {{ currentYear }} {{ $t('footer.rights') }}</span></li>
            </ul>
        </div>
        <div class="grid grid-cols-2 justify-items-center w-full sm:flex sm:items-center sm:justify-between md:w-max md:gap-2">
          <a target="_blank" href="https://www.facebook.com/echopus" class="relative py-1.5 overflow-hidden flex items-center gap-2 px-2 sm:px-5 menu_link">
              <AppIcon name="facebook-01" class="text-lg text-primary" />
              <span class="text-xs sm:text-base">Facebook</span>
          </a>
          <a target="_blank" href="https://www.instagram.com/echoopus/" class="relative py-1.5 overflow-hidden flex items-center gap-2 px-2 sm:px-5 menu_link">
              <AppIcon name="instagram" class="text-lg text-primary" />
              <span class="text-xs sm:text-base">Instagram</span>
          </a>
          <a target="_blank" href="https://www.linkedin.com/company/echopus/" class="relative py-1.5 overflow-hidden flex items-center gap-2 px-2 sm:px-5 menu_link">
              <AppIcon name="linkedin-01" class="text-lg text-primary" />
              <span class="text-xs sm:text-base">Linkedin</span>
          </a>
          <a target="_blank" href="https://www.tiktok.com/@echoopus" class="relative py-1.5 overflow-hidden flex items-center gap-2 px-2 sm:px-5 menu_link">
              <AppIcon name="tiktok" class="text-lg text-primary" />
              <span class="text-xs sm:text-base">TikTok</span>
          </a>
        </div>
    </div>

    <div class="flex items-center justify-around h-full">
        <div class="border-l border-primary-light block h-[30px]"></div>
        <div class="border-l border-primary-light block h-[30px]"></div>
      </div>
    </div>
</template>

<script setup>
import logoTypoWhite from '~/assets/icons/logo-typo-white.svg'

// The HTML is generated ahead of time: hydrate with the build year (from the payload), then show
// the visitor's year, so a build from last year neither shows a stale year nor mismatches.
const currentYear = useState('currentYear', () => new Date().getFullYear())
onMounted(() => {
  currentYear.value = new Date().getFullYear()
})
</script>
